import { Super } from './super.model';

export class AssignmentType extends Super<AssignmentType> {

    public name: string;
    public slug: string;
    public description: string;
}